









































































































































































































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import BaseServiceMixin from "../mixins/base.service.mixin";
import TwilioService from "@/services/twilio.service";
import TwilioWorkerModel from "../models/TwilioWorkerModel";
import TwilioQueueModel from "../models/TwilioQueueModel";
import Filters from "../common/Filters";
import { TwilioTaskStatus } from "../common/enum";
import { TwilioTaskModel } from "../models/TwilioTaskModel";
import { ValidationObserver } from "vee-validate";
import eventBus from "../common/bus";
import vueCustomScrollbar from "vue-custom-scrollbar";
import ExpandedTaskModal from "@/components/Modals/ExpandedTaskModal.vue";
import CancelTaskModal from "@/components/Modals/CancelTaskModal.vue";
import WorkerExpandedInfoModal from "@/components/Modals/WorkerExpandedInfoModal.vue";
import SignalRService from "../services/signalr.service";
import { CompanyModel } from "@/models/CompanyModel";
import CompanyService from "@/services/company.service";
import moment from "moment";

let timer: NodeJS.Timer | null = null;

@Component({
  components: {
    ValidationObserver,
    vueCustomScrollbar,
    CancelTaskModal,
    ExpandedTaskModal,
  },
  filters: {
    diffToString: Filters.diffToString,
  },
})
export default class Respond extends Mixins(BaseServiceMixin) {
  private twilioService!: TwilioService;
  private signalRService!: SignalRService;
  private companyService!: CompanyService;

  private workers: TwilioWorkerModel[] = [];
  private queues: TwilioQueueModel[] = [];

  private loadingQueue = false;
  private loadingWorker = false;
  private loading = false;
  private firstLoadCompleted = false;
  private updateTime = "";

  private taskSelector: TwilioTaskModel = new TwilioTaskModel();
  private taskToCancel: TwilioTaskModel = new TwilioTaskModel();

  private isModelActive = false;
  private reason = "";

  private companies: CompanyModel[] = [];
  private companyId = 0;

  public isCardModalActive = false;

  private get isZing(): boolean {
    return this.vuexStore.user ? this.vuexStore.user.isZing : false;
  }

  private get company(): CompanyModel | null {
    return this.vuexStore.company;
  }

  public async created() {
    this.twilioService = new TwilioService(this.axiosInstance);
    this.companyService = new CompanyService(this.axiosInstance);
    this.signalRService = new SignalRService(this.axiosInstance, "zingRespond");
    this.signalRService.addHandler("worker-message", this.onWorkerUpdate);
    this.signalRService.addHandler("task-message", this.onTaskUpdate);
  }

  private async mounted() {
    if (timer) clearInterval(timer);
    timer = setInterval(this.updateQueueTime, 1000);

    if (this.company) {
      this.companyId = this.company.id;
    }
    if (this.isZing) {
      await this.getCompanies();
    }

    try {
      await this.signalRService.connectHub();
    } catch (e) {
      // handle error
    }
  }

  @Watch("company", { deep: true })
  private async userCompanyChange() {
    this.companyId = this.company ? this.company.id || 0 : 0;
  }

  @Watch("companyId")
  private async getRecords() {
    if (!this.companyId) {
      return;
    }

    this.loading = true;
    try {
      await this.getWorkers();
      await this.getQueues();
    } catch (error) {
      this.workers = [];
      this.queues = [];
    } finally {
      this.loading = false;
    }
  }

  private updateQueueTime() {
    try {
      this.queues.forEach((q) => {
        q.tasks.forEach((t) => {
          if (!t.timeSinceCreated) t.timeSinceCreated = 0;
          t.timeSinceCreated++;
        });
      });
    } catch (error) {
      // just don't crash, doesn't matter if we can't update really
    }
  }

  private async getCompanies() {
    try {
      this.companies = await this.companyService.getCompanyList();
    } catch (error) {
      // Handle Error
    }
  }

  private async getWorkers() {
    this.loadingWorker = true;
    try {
      this.workers = await this.twilioService.getWorkers(this.companyId);
      this.sortWorkers();
    } catch (error) {
      throw new Error();
    } finally {
      this.loadingWorker = false;
    }
  }

  private sortWorkers() {
    const availableWorker = this.workers.filter((x) => x.activity === "Available");
    const unavailableWorker = this.workers.filter((x) => x.activity === "Unavailable");
    const offlineWorker = this.workers.filter((x) => x.activity === "Offline");
    const otherWorker = this.workers.filter((x) => !["Available", "Unavailable", "Offline"].includes(x.activity));

    this.workers = [...availableWorker, ...unavailableWorker, ...otherWorker, ...offlineWorker];
  }

  private getWorkerStatusColor(status: string): string {
    switch (status) {
      case "Available":
        return "is-success";
      case "Unavailable":
        return "is-warning";
      case "Offline":
        return "is-grey";
      default:
        return "is-info";
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private async onWorkerUpdate(data: any) {
    const updatedWorker: TwilioWorkerModel = data.Worker;
    const i = this.workers.findIndex((x) => x.sid == updatedWorker.sid);
    if (i >= 0) {
      this.workers[i].activity = updatedWorker.activity;
      this.sortWorkers();
      await this.getQueues();
    }
  }

  private async getQueues() {
    this.loadingQueue = true;

    try {
      this.queues = await this.twilioService.getTwilioQueues(this.companyId);
    } catch (error) {
      throw new Error();
    } finally {
      this.loadingQueue = false;
      if (!this.firstLoadCompleted) {
        this.firstLoadCompleted = true;
      }
      this.updateTime = moment().format("HH:mm");
    }
  }

  private getTaskStatusColor(status: TwilioTaskStatus): string {
    switch (status) {
      case TwilioTaskStatus.Pending:
        return "is-warning";
      case TwilioTaskStatus.Reserved:
        return "is-info";
      case TwilioTaskStatus.Assigned:
        return "is-success";
      case TwilioTaskStatus.Canceled:
        return "is-danger";
      case TwilioTaskStatus.Completed:
        return "is-primary";
      case TwilioTaskStatus.Wrapping:
        return "is-grey";
      default:
        return "is-grey";
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private onTaskUpdate(data: any) {
    const updatedTask: TwilioTaskModel = data.Task;
    const queueName: string = data.QueueName;
    const queueIndex = this.getQueueIndex(queueName);

    this.updateTime = moment().format("HH:mm:ss");

    if (queueIndex < 0) {
      return;
    }

    if ([TwilioTaskStatus.Pending, TwilioTaskStatus.Reserved, TwilioTaskStatus.Assigned].includes(updatedTask.status)) {
      const taskIndex = this.getTaskIndex(queueIndex, updatedTask.sid);
      if (taskIndex >= 0) {
        Object.assign(this.queues[queueIndex].tasks[taskIndex], updatedTask);
      } else {
        this.queues[queueIndex].tasks.push(updatedTask);
      }
    } else {
      const taskIndex = this.getTaskIndex(queueIndex, updatedTask.sid);
      if (taskIndex >= 0) {
        this.queues[queueIndex].tasks.splice(taskIndex, 1);
      }
    }
  }

  private getQueueIndex(queueName: string) {
    return this.queues.findIndex((x) => x.queueName === queueName);
  }

  private getTaskIndex(queueIndex: number, taskSid: string) {
    return this.queues[queueIndex].tasks.findIndex((x) => x.sid === taskSid);
  }

  private allowedCancel(status: TwilioTaskStatus): boolean {
    return status === TwilioTaskStatus.Pending || status === TwilioTaskStatus.Reserved;
  }

  private async onTaskExpand(task: TwilioTaskModel) {
    this.taskSelector = new TwilioTaskModel();
    this.taskToCancel = task;
    this.$buefy.modal.open({
      parent: this,
      props: {
        task,
        companyId: this.companyId,
        allowedToCancel: this.allowedCancel(task.status),
      },
      events: {
        onCancelTask: this.onCancelTask,
      },
      scroll: "keep",
      component: ExpandedTaskModal,
      hasModalCard: true,
      trapFocus: true,
      ariaRole: "dialog",
      ariaModal: true,
      width: "80%",
    });
  }

  private async onTaskDelete(task: TwilioTaskModel) {
    this.taskSelector = new TwilioTaskModel();
    this.$buefy.dialog.confirm({
      title: "Delete this Task?",
      message: `Are you sure you want to delete this task?`,
      cancelText: "Cancel",
      confirmText: "Delete this Task",
      type: "is-danger",
      onConfirm: () => this.deleteTask(task),
    });
  }

  private async deleteTask(task: TwilioTaskModel) {
    eventBus.$emit("loading", true);
    try {
      await this.twilioService.deleteTwilioTask(this.companyId, task);
    } catch (error) {
      // Handle Error
    } finally {
      setTimeout(() => {
        eventBus.$emit("loading", false);
      }, 1000);
    }
  }

  private async onTaskCancel(task: TwilioTaskModel) {
    this.taskSelector = new TwilioTaskModel();
    this.taskToCancel = task;
    this.$buefy.modal.open({
      parent: this,
      props: {
        task,
        companyId: this.companyId,
      },
      events: {
        onCancelTask: this.onCancelTask,
      },
      scroll: "keep",
      component: CancelTaskModal,
      hasModalCard: true,
      trapFocus: true,
      ariaRole: "dialog",
      ariaModal: true,
      width: "80%",
      canCancel: ["escape", "x"],
    });
  }

  private async onCancelTask() {
    this.closeModel();
  }

  private closeModel() {
    this.taskToCancel = new TwilioTaskModel();
    this.isModelActive = false;
    this.reason = "";
  }

  private async destroyed() {
    try {
      await this.signalRService.disconnectHub();
    } catch (err) {
      // handle error
    }
  }

  private activateModel(worker: TwilioWorkerModel) {
    this.$buefy.modal.open({
      parent: this,
      props: {
        worker,
        companyId: this.companyId,
      },
      scroll: "keep",
      component: WorkerExpandedInfoModal,
      hasModalCard: true,
      trapFocus: true,
      ariaRole: "dialog",
      ariaModal: true,
      canCancel: ["escape", "x"],
    });
  }
}
